<template>
  <div class="main-body">
    <div class="page-attention">
      <p>商品品牌只做显示关联使用</p>
    </div>
    <a-divider />
    <a-form :model="formState" autocomplete="off" :label-col="labelCol" :wrapper-col="wrapperCol" @finish="onSubmit">
      <a-form-item label="品牌名称" name="brand_name" :rules="[{ required: true, message: '请输入品牌名称!' }]">
        <a-input class="half-input" v-model:value="formState.brand_name" placeholder="请输入品牌名称" />
      </a-form-item>
      <a-form-item label="品牌图标" name="brand_image">
        <CsImage v-model:imgOne="formState.brand_image" />
      </a-form-item>
      <a-form-item label="排序" name="sort" extra="数字越大，排序越靠前，数字重复，则最新添加的靠前。">
        <a-input-number class="medium-input" v-model:value="formState.sort" :min="0" :max="1000000" />
      </a-form-item>
      <a-form-item class="form-submit-layout">
        <a-button type="primary" html-type="submit">保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { defineComponent, reactive } from "vue";
import CsImage from "@/components/UpImage";

export default defineComponent({
  components: {
    CsImage,
  },
  setup() {
    const formState = reactive({
      brand_name: "",
      brand_image: "",
      sort: "0",
    });

    const onSubmit = () => {};

    return {
      labelCol: {
        style: {
          width: "100px",
        },
      },
      labelColSecond: {
        style: {
          width: "44px",
        },
      },
      wrapperCol: {
        span: 7,
      },
      formState,
      onSubmit,
    };
  },
});
</script>